import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=5639bd82&scoped=true&"
import script from "./Province.vue?vue&type=script&lang=js&"
export * from "./Province.vue?vue&type=script&lang=js&"
import style0 from "./Province.vue?vue&type=style&index=0&id=5639bd82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639bd82",
  null
  
)

export default component.exports